<div [formGroup]="form" [ngClass]="{'inverted': invertedColor}" class="component-wrapper">
  <div class="label-wrapper">
    @if (label) {
      <label
        [for]="HTML_ID"
        [ngClass]="{'small': isSmallLabel}">
        <span [attr.data-cy]="labelCypressTag">{{label}}</span>
      </label>
    }
    @if (hasWarningStar) {
      <app-warning-star
        [attr.data-cy]="warningStarCypressTag"
      [type]="warningLevel"></app-warning-star>
    }
    <div [attr.data-cy]="labelInformationCypressTag"
      class="label-information">
      <ng-container *ngTemplateOutlet="labelInformation"></ng-container>
    </div>
  </div>


  <div #dropdown="ngbDropdown"
    [attr.data-cy]="inputWrapperCypressTag" [ngClass]="{'invalid': !isValid, 'focus': isFocused, 'disabled': isDisabled, 'alternate-background': alternateBackground}"
    autoClose="outside" class="input-wrapper" ngbDropdown>
    <app-tooltip [disable]="inputHasEllipsis" [dynamic]="false" [message]="inputTextString">
      <input (blur)="inputBlur.emit($event)"
        (click)="inputClick.emit($event)"
        (focus)="inputFocus.emit($event)"
        (keydown)="inputKeyDown.emit($event)"
        (mouseenter)="toggleTooltip($event)"
        [attr.data-cy]="textInputCypressTag"
        [formControlName]="FORM_CONTROL_NAME"
        [id]="HTML_ID"
        [ngStyle]="inputHeight"
        [placeholder]="placeholder"
        [value]="inputTextString"
        class="input text-ellipsis"
        ngbDropdownToggle
        readonly="readonly"
        type="text">
    </app-tooltip>


    <div id="override-dropdown-position" ngbDropdownMenu>
      @for (option of options; track option) {
        <div [attr.data-cy]="optionDataCy"
          [ngClass]="{'selected': optionIsChecked(option), 'disabled': !option.active}"
          class="input-multiselect-dropdown-option">
          <input (change)="optionCheckedStatusChange(option)" [checked]="optionIsChecked(option)" [id]="getOptionId(option)"
            class="input-multiselect-dropdown-option-checkbox"
            data-cy="input-multiselect-dropdown-option-checkbox"
            ngbDropdownItem
            type="checkbox">
          <label [for]="getOptionId(option)"
            class="input-multiselect-dropdown-option-label"
          data-cy="input-multiselect-dropdown-option-label">{{option.label}}</label>
        </div>
      }
    </div>

    <div class="icon-wrapper">
      @if (hasDeleteButton) {
        <button (click)="deleteInputValue()"
          [attr.data-cy]="deleteButtonCypressTag"
          class="input-button">
          <span [class]="deleteButtonIconClass"></span>
        </button>
      }
      <button (click)="clickOnArrow($event)"
        [attr.data-cy]="dropdownButtonCypressTag"
        [disabled]="isInputDisabled"
        class="input-button">
        <span [class]="getDropdownButtonIconClass($safeNavigationMigration(dropdown?.isOpen()))"></span>
      </button>
    </div>
  </div>

  @if (showMessages) {
    @for (message of messages | anyKeyValue; track message) {
      @if (message.value.length > 0) {
        <app-warning-inline
          [warningInlineLabelsArray]="message.value"
        [warningType]="message.key"></app-warning-inline>
      }
    }
  }

</div>

